import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import {
  fetchUserDetails,
  getAccessToken,
  getRefreshToken,
  refreshAccessToken,
  removeTokens,
} from "../services/authService";
import {
  buildAuthenticatedReportUrl,
  routeBasedOnSubscription,
} from "../services/commonService";

const useAuth = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    if (path === "/login") {
      return;
    }

    const handleLogout = () => {
      removeTokens();
      navigate("/login", { replace: true });
    };

    const authenticate = async () => {
      const token = getAccessToken();

      if (!token) {
        navigate("/login", { replace: true });
        return;
      }

      let userInfo;
      try {
        userInfo = await fetchUserDetails();
      } catch {
        handleLogout();
        return;
      }

      if (userInfo?.growth_iq !== 1) {
        removeTokens();
        navigate("/login", { replace: true });
        return;
      }

      const role = userInfo?.growth_iq_role_name;

      const isAdmin =
        role === "ROLE_MNM_SUBSCRIBER" || role === "ROLE_ACCOUNT_MANAGER";

      const isClientIndustry = path.includes("client_industry");

      if (isClientIndustry && !isAdmin) {
        if (userInfo?.has_ask_growth_access === 1)
          navigate("/watchboard", { replace: true });
        else if (userInfo?.has_comp_iq_access === 1)
          navigate("/clients_competitors", { replace: true });
        else if (userInfo?.salesplay === 1)
          navigate("/customers", { replace: true });
        else navigate("/news", { replace: true });
        return;
      }

      if (isAdmin) return;

      const isSubscriber =
        role === "ROLE_SUBSCRIBER_EMPLOYEE" || role === "ROLE_SUBSCRIBER_ADMIN";

      if (!isSubscriber) {
        handleLogout();
        return;
      }

      const isWatchboard = path.includes("watchboard");
      const isCompIQRoute = [
        "clients_competitors",
        "comp_profile",
        "benchmarks",
      ].some((r) => path.includes(r));
      const isCustomer = path.includes("customers");

      if (isWatchboard && userInfo?.has_ask_growth_access !== 1) {
        navigate("/news", { replace: true });
      }

      if (isCompIQRoute && userInfo?.has_comp_iq_access !== 1) {
        navigate("/news", { replace: true });
      }

      if (isCustomer && userInfo?.salesplay !== 1) {
        navigate("/news", { replace: true });
      }
    };

    authenticate();
  }, [navigate, location.pathname]);
};

export default useAuth;
